module.exports = __webpack_public_path__ + "static/img/gdjt4.9f94073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdjt4.png
// module id = Cn9/
// module chunks = 1